const CharacterScopeColours = {
  innovator: "rgb(109, 200, 191)",
  entrepreneurial: "rgb(248, 195, 28)",
  executional: "rgb(243, 161, 35)",
  practical: "rgb(192, 192, 192)",
  strategist: "rgb(130,60,190)",
  servant: "rgb(191, 18, 36)",
  transformational: "rgb(243, 11, 111)",
  charismatic: "rgb(176, 187, 54)",
  professional: "rgb(103, 166, 220)",
};

export { CharacterScopeColours as default };
